export { default } from '../../shop/[category]';
